export default __webpack_public_path__ + "static/media/alin-cohen.214ddc21.png";